import { z } from "zod";
import { BladeCommonSchema } from "../../../types";
import { AudioMediaSchema } from "../../../components/Media";
export const AudioItemBladeSchema = BladeCommonSchema.extend({
    audio: AudioMediaSchema,
    caption: z.string().optional(),
});
//# sourceMappingURL=index.js.map